import xss, { IFilterXSSOptions } from 'xss'

const defaultOptions: IFilterXSSOptions = {
  whiteList: {
    a: ['target', 'href', 'title'],
    b: [],
    blockquote: [],
    br: [],
    div: [],
    em: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    iframe: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen'],
    img: [],
    li: [],
    ol: [],
    p: [],
    s: [],
    span: [],
    strong: [],
    table: [],
    tbody: [],
    td: [],
    tfoot: [],
    th: [],
    thead: [],
    tr: [],
    u: [],
    ul: [],
  },
}

export const sanitizeHtml = (dirty: string, options: IFilterXSSOptions = defaultOptions) => xss(dirty, options)
